export const appMetricLabels = {
  investido: "Investido",
  "investido-faturado": "Investido com imposto",
  "compras-meta": "Compras segundo o Meta",
  "valor-compras-meta": "Valor das compras (Meta)",
  "roas-meta": "ROAS do Meta",
  "custo-por-compra-meta": "Custo por compra (Meta)",
  pedidos: "Pedidos",
  vendas: "Vendas",
  "vendas-sem-anuncio": "Vendas sem anúncio identificado",
  "vendas-outros-anuncios": "Vendas de outros anúncios",
  "vendas-loja": "Vendas da loja",
  "pedidos-loja": "Pedidos da loja",
  "investido-sobre-vendas-loja": "Investido ÷ vendas da loja",
  mer: "MER",
  "mer-sem-imposto": "MER sem imposto",
  "sessoes-loja": "Sessões na loja",
  "sessoes-com-carrinho": "Sessões com carrinho",
  "sessoes-no-checkout": "Sessões no checkout",
  "sessoes-com-pedido": "Sessões com pedido",
  "carrinho-sobre-sessoes": "Sessão → carrinho",
  "pedido-sobre-checkout": "Checkout → pedido",
  retorno: "Retorno",
  "retorno-sem-imposto": "Retorno sem imposto",
  "custo-por-pedido": "Custo por pedido",
  "custo-por-pedido-sem-imposto": "Custo por pedido sem imposto",
  impressoes: "Impressões",
  alcance: "Alcance",
  frequencia: "Frequência",
  cliques: "Cliques",
  "cliques-link": "Cliques no link",
  "ctr-link": "CTR do link",
  "cpc-link": "Custo por clique no link",
  cpm: "CPM",
  "visualizacoes-pagina-destino": "Visualizações da página de destino",
  checkouts: "Checkouts iniciados",
  "custo-por-checkout": "Custo por checkout",
  leads: "Leads",
  "custo-por-lead": "Custo por lead",
  "taxa-gancho": "Taxa de gancho",
  "visualizacoes-3s": "Visualizações de 3 s",
  thruplays: "ThruPlays",
  "orcamento-diario": "Orçamento/dia",
} as const;

export const additionalMetricLabels = {
  "visualizacoes-conteudo": "Visualizações de conteúdo",
  "adicoes-carrinho": "Adições ao carrinho",
  "video-25": "Vídeo visto até 25%",
  "video-50": "Vídeo visto até 50%",
  "video-75": "Vídeo visto até 75%",
  "video-100": "Vídeo visto até o fim",
  "compras-esperadas": "Compras estimadas pelas visitas",
  dias: "Dias sem evento",
  "pedidos-pagos": "Pedidos pagos",
  "investido-por-pedido-pago": "Investido com imposto por pedido pago",
} as const;

export const metricLabels = { ...appMetricLabels, ...additionalMetricLabels } as const;
